import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";
import TabsComponent from "./TabsComponent";
import KeyValueTable from "../Common/KeyValueTable";

import coreUtils from "../../utils/coreUtils";
import { getVariableSet } from "redux-store/variableSetReducers/variableSetActions";
import { useDispatch } from "react-redux";

const buildResponseVariables = (testCaseSetList, testCaseSetId) => {
  let responseVariables = [];

  let index = 0;
  while (index < testCaseSetList.length) {
    if (testCaseSetList[index].id === testCaseSetId) {
      break;
    }
    responseVariables.push({
      var_name: `response${index + 1}_status`,
      var_value: testCaseSetList[index].test_case_set_response?.status
    })
    responseVariables.push({
      var_name: `response${index + 1}_headers`,
      var_value: testCaseSetList[index].test_case_set_response?.headers
    })
    responseVariables.push({
      var_name: `response${index + 1}_body`,
      var_value: testCaseSetList[index].test_case_set_response?.body
    })
    index += 1;
  }
  responseVariables.push({
    var_name: 'current_response_status',
    var_value: testCaseSetList[index].test_case_set_response?.status
  })
  responseVariables.push({
    var_name: 'current_request_time',
    var_value: testCaseSetList[index].test_case_set_response?.time_in_ms
  })
  responseVariables.push({
    var_name: 'current_request_started_at',
    var_value: testCaseSetList[index].test_case_set_response?.request_started_at
  })
  responseVariables.push({
    var_name: 'current_request_body',
    var_value: testCaseSetList[index].test_case_set_response?.request_body
  })
  responseVariables.push({
    var_name: 'current_response_headers',
    var_value: testCaseSetList[index].test_case_set_response?.headers
  })
  responseVariables.push({
    var_name: 'current_response_body',
    var_value: testCaseSetList[index].test_case_set_response?.body
  })
  return responseVariables;

}

const EntityVariables = ({ testCaseSetId, selectedEnvironmentId }) => {
  const selectedTestScenarioDetail = useSelector(
    (state) => state.testScenario.selectedTestScenarioDetail
  );
  const testCaseSetList = useSelector(state => (state.testCaseSet.testCaseSetList));
  const tabLabels = ["Response", "Environment"];
  const [activeTab, setActiveTab] = useState(0);
  const dispatch = useDispatch();
  const [environmentVariables, setEnvironmentVariables] = useState(null);


  const handleTabChange = (event, tabIndex) => {
    setActiveTab(tabIndex);
  };


  useEffect(() => {
    const checkAndFetchVariables = async () => {
      try {
        const result = await dispatch(getVariableSet({
          variableSetId: selectedEnvironmentId
        })).unwrap();

        if (result) {
          setEnvironmentVariables(result.variables);
        }
      } catch (error) {
        console.error('Error fetching variable set:', error);
      }
    };
    setEnvironmentVariables(null);
    checkAndFetchVariables();
  }, [selectedEnvironmentId]);


  const renderTabContent = () => {
    let parsedVariables;
    switch (activeTab) {
      case 0:
        let responseVariables = buildResponseVariables(testCaseSetList, testCaseSetId);
        return <KeyValueTable allItems={responseVariables} sxCell={{ textAlign: "left" }} json={true} isReadOnly enableCopyPath={true} showSerialNumber={false} />;
      case 1:
        parsedVariables = coreUtils.parseVariablesArray(environmentVariables === null ? {} : environmentVariables);
        return <KeyValueTable allItems={parsedVariables} sxCell={{ textAlign: "left" }} json={true} isReadOnly />;
      default:
        return null;
    }
  };
  return (
    <Box sx={{ py: 2 }}>
      <TabsComponent
        tabLabels={tabLabels}
        activeTab={activeTab}
        handleTabChange={handleTabChange}
        customTabStyle={{ width: "auto", fontSize: "12px", fontWeight: 600 }}
        tabsStyle={{ border: "none" }}
        activeTabStyle={{ backgroundColor: "transparent" }}
      />
      <Box sx={{ height: "425px", overflow: "auto" }}>{renderTabContent()}</Box>
    </Box>
  );
};

export default EntityVariables;
